import {localURL, caseDataApi, allCaseDataApi} from '../../constants/apiConstants';
import mode from '../mode';
import {createFetchAndCall} from '../fetch/fetchServices';
import {createCaseDataObject} from '../../components/caseData/caseDataModel';

class caseData {
  static createCaseData(case_data) {
    let caseDataApiPath = createCaseDataApi(caseDataApi);
    let headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(createCaseDataObject(case_data))
    };
    return createFetchAndCall(caseDataApiPath, options);
  }

  static getCaseData(link) {
    link = createCaseDataApi(link);
    let headers = {
      'accept': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(link, options);
  }

  static getAllCaseData(establishmentId) {
    let link = createAllCaseDataApi(allCaseDataApi, establishmentId);
    let headers = {
      'accept': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(link, options);
  }

  static editCaseData(summary, formId) {
    let caseDataApiPath = createCaseDataApi(caseDataApi, formId);
    let headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(createCaseDataObject(summary))
    };
    return createFetchAndCall(caseDataApiPath, options);
  }
}

function createCaseDataApi(link, formId) {
  if(formId) {
    link = `${link}/${formId}`;
  }
  if (!mode.prod) {
    link = `${localURL}${link}`;
  }
  return link;
}

function createAllCaseDataApi(link, establishmentId) {
  if(establishmentId) {
    link = `${link}/${establishmentId}`;
  }
  if (!mode.prod) {
    link = `${localURL}${link}`;
  }
  return link;
}
export default caseData;



/** WEBPACK FOOTER **
 ** ./src/api/forms/caseDataApi.js
 **/